class WallpaperItem {
  constructor(el) {
    this._bind();

    this.dom = {
      el: el,

      // Colors
      colors: el.querySelectorAll(".color-container .color"),
      removeableBtn: el.querySelector(".button[data-type='removable']"),
      traditionalBtn: el.querySelector(".button[data-type='traditional']"),
      grassclothBtn: el.querySelector(".button[data-type='grasscloth']"),

      // Images
      images: el.querySelectorAll(".variant-images img"),

      // Overlay Container
      overlayContainer: el.querySelector(".overlay-container"),
      addSampleContainer: el.querySelector(".add-sample-container"),
      optionContainer: el.querySelector(".option-container"),
      sampleButtons: el.querySelectorAll(".option-container span"),
    }

    // if (this.dom.images?.length > 0) {
      this.dom.images[0].classList.add("active");
    // }
    if (this.dom.colors?.length > 0) {
      this.dom.colors[0].classList.add("is-selected");
    }

    this._addEvents();
  }

  _bind() {
    ['changeImage', 'sampleStepOne', 'sampleResetSteps']
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  _addEvents() {
    this.dom.colors.forEach((color, i) => {
      color.addEventListener("click", () => {

        if (color.getAttribute("data-removable-id")) {
          // console.log(color.getAttribute("data-removable-id"))
          this.dom.removeableBtn.setAttribute("data-id", color.getAttribute("data-removable-id"));
        }

        if (color.getAttribute("data-traditional-id")) {
          // console.log(color.getAttribute("data-traditional-id"))

          this.dom.traditionalBtn.setAttribute("data-id", color.getAttribute("data-traditional-id"));
        }

        if (color.getAttribute("data-grasscloth-id")) {
          // console.log(color.getAttribute("data-traditional-id"))

          this.dom.grassclothBtn.setAttribute("data-id", color.getAttribute("data-grasscloth-id"));
        }

        this.changeImage(i);
      }, false)
    });

    if (this.dom.addSampleContainer) {

      this.dom.addSampleContainer.addEventListener("click", this.sampleStepOne, false)

      this.dom.sampleButtons.forEach(el => {

        let type = el.dataset ? el.dataset.type : null;
        let id = el.dataset ? el.dataset.id : null;

        el.addEventListener("click", (e) => { this.addSample(type, id, e) })
      });

      this.dom.overlayContainer.querySelectorAll(".button").forEach(button => {
        button.addEventListener("click", () => {
          button.classList.add("clicked");
        })
      })

      this.dom.el.addEventListener("mouseleave", this.sampleResetSteps, false)
    }
  }

  changeImage(i) {
    // console.log(`new Image: ${i}`);

    const currentImage = this.dom.el.querySelector(".variant-images img.active")
    if (currentImage) currentImage.classList.remove("active")
    this.dom.images[i].classList.add("active")

    const currentColor = this.dom.el.querySelector(".color-container .color.is-selected")
    if (currentColor) currentColor.classList.remove("is-selected")
    this.dom.colors[i].classList.add("is-selected")
  }


  // Add Sample
  sampleStepOne() {
    gsap.set(this.dom.addSampleContainer, { autoAlpha: 0, pointerEvents: "none" })
    gsap.set(this.dom.optionContainer, { autoAlpha: 1, pointerEvents: "all" })
  }

  addSample(type, id, e) {
    // console.log(`Open mini Cart ${type} ${id}`);
    id = e.target.dataset.id;
    let formData = {
      'items': [{
        'id': id,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  sampleResetSteps() {
    gsap.set(this.dom.addSampleContainer, { autoAlpha: 1, pointerEvents: "all", delay: 0.3 })
    gsap.set(this.dom.optionContainer, { autoAlpha: 0, pointerEvents: "none", delay: 0.3 })

    this.dom.overlayContainer.querySelectorAll(".button").forEach(button => {
      button.classList.remove("clicked");
    })
  }
}